import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

interface HelpHeroProps {
  eyebrow: string
  title: ReactNode
  subtitle?: string
  size?: 'xl' | 'md'
  cta?: { label: string; to: string }
}

export function HelpHero({ eyebrow, title, subtitle, size = 'md', cta }: HelpHeroProps) {
  const titleClass =
    size === 'xl'
      ? 'font-display text-4xl font-black leading-[1.05] sm:text-5xl md:text-6xl lg:text-7xl'
      : 'font-display text-3xl font-black leading-[1.1] sm:text-4xl md:text-5xl'
  return (
    <header className="mb-10 md:mb-14">
      <p className="font-brutal text-xs font-bold uppercase tracking-[0.18em] text-red sm:text-sm">
        {eyebrow}
      </p>
      <h1 className={`mt-3 ${titleClass}`}>{title}</h1>
      {subtitle && (
        <p className="mt-4 max-w-2xl text-base text-muted-foreground sm:text-lg">{subtitle}</p>
      )}
      {cta && (
        <Link
          to={cta.to}
          className="brutal mt-6 inline-flex items-center gap-2 bg-red px-5 py-3 font-display text-sm font-bold uppercase tracking-widest text-white transition-transform hover:-translate-y-0.5"
        >
          {cta.label} →
        </Link>
      )}
    </header>
  )
}
